import { render } from "./SizeFormCustom.vue?vue&type=template&id=52c25c0c&scoped=true"
import script from "./SizeFormCustom.vue?vue&type=script&lang=js"
export * from "./SizeFormCustom.vue?vue&type=script&lang=js"

import "./SizeFormCustom.vue?vue&type=style&index=0&id=52c25c0c&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c25c0c"]])

export default __exports__